import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Button, Divider, Modal, Spin } from "antd";
import ConsignmentReusablePackagingTable from "./ConsignmentReusablePackagingTable";
import ConsignmentReusablePackagingEditModal from "./ConsignmentReusablePackagingEditModal";
import { userHasPermission } from "../../../../swzutils/UserPermissionsUtil";
import { axiosErrorHandler } from "../../../../swzutils";
import ConsignmentReusablePackagingResource from "./api/ConsignmentReusablePackagingResource";
import { useAppSelector } from "../../../../store";
import { loggedInUserSelector } from "../../../../store/slice/auth";
const ConsignmentReusablePackagingPanel = ({ consignmentId, consignmentTenantId, canUpdate = false }) => {
    const [networkRequestInProgress, setNetworkRequestInProgress] = useState(false);
    const [editModalVisible, setEditModalVisible] = useState(false);
    const [editingReusablePackaging, setEditingReusablePackaging] = useState(undefined);
    const [reusablePackagingList, setReusablePackagingList] = useState([]);
    const loggedInUser = useAppSelector(loggedInUserSelector);
    const [modal, contextHolder] = Modal.useModal();
    useEffect(() => {
        if (consignmentId) {
            ConsignmentReusablePackagingResource.get(consignmentId, setReusablePackagingList, axiosErrorHandler, () => setNetworkRequestInProgress(false));
        }
    }, [consignmentId]);
    const addReusablePackaging = () => {
        setEditingReusablePackaging(undefined);
        setEditModalVisible(true);
    };
    const editReusablePackaging = (editingReusablePackaging) => {
        setEditingReusablePackaging(editingReusablePackaging);
        setEditModalVisible(true);
    };
    const hideEditModal = () => {
        setEditModalVisible(false);
        setEditingReusablePackaging(undefined);
        setNetworkRequestInProgress(false);
    };
    const confirmDelete = (reusablePackaging) => {
        modal.confirm({
            title: 'Are you sure?',
            content: 'This will remove the reusable packaging from this consignment',
            okText: 'Yes',
            cancelText: 'No',
            onOk: () => {
                deleteReusablePackaging(reusablePackaging);
            }
        });
    };
    const deleteReusablePackaging = (reusablePackaging) => {
        setNetworkRequestInProgress(true);
        ConsignmentReusablePackagingResource.delete(consignmentId, reusablePackaging.id, () => setReusablePackagingList(reusablePackagingList.filter(rp => rp.id !== reusablePackaging.id)), axiosErrorHandler, () => setNetworkRequestInProgress(false));
    };
    const onSave = (formValues) => {
        setNetworkRequestInProgress(true);
        const updateRequest = {
            "reusablePackagingId": formValues.reusablePackagingId,
            "scheduledPickupQuantity": formValues.scheduledPickupQuantity,
            "scheduledDropQuantity": formValues.scheduledDropQuantity,
            "returnToSenderReceiverId": formValues.returnToSenderReceiverId,
            "version": editingReusablePackaging?.version
        };
        if (editingReusablePackaging) {
            ConsignmentReusablePackagingResource.update(consignmentId, editingReusablePackaging.id, updateRequest, updated => {
                setReusablePackagingList(reusablePackagingList.map(rp => {
                    if (rp.id === updated.id) {
                        return updated;
                    }
                    return rp;
                }));
            }, axiosErrorHandler, () => hideEditModal());
        }
        else {
            ConsignmentReusablePackagingResource.create(consignmentId, updateRequest, added => setReusablePackagingList([...reusablePackagingList, added]), axiosErrorHandler, () => hideEditModal());
        }
    };
    return (_jsxs(Spin, { spinning: networkRequestInProgress, children: [contextHolder, _jsxs("div", { children: [canUpdate && userHasPermission(loggedInUser, ['admin:consignmentReusablePackaging:create']) &&
                        _jsx("p", { children: _jsx(Button, { size: "small", onClick: addReusablePackaging, children: "Add Reusable Packaging" }) }), _jsx(ConsignmentReusablePackagingTable, { reusablePackagings: reusablePackagingList, hasActions: canUpdate && userHasPermission(loggedInUser, ['admin:consignmentReusablePackaging:update', 'admin:consignmentReusablePackaging:delete']), renderActions: (reusablePackaging) => (_jsxs("span", { children: [canUpdate && userHasPermission(loggedInUser, ['admin:consignmentReusablePackaging:update']) &&
                                    _jsx(Button, { size: "small", onClick: () => editReusablePackaging(reusablePackaging), children: "Edit" }), _jsx(Divider, { orientation: "vertical" }), canUpdate && userHasPermission(loggedInUser, ['admin:consignmentReusablePackaging:delete']) &&
                                    _jsx(Button, { size: "small", onClick: () => confirmDelete(reusablePackaging), children: "Remove" })] })) }), _jsx(ConsignmentReusablePackagingEditModal, { tenantId: consignmentTenantId, showSpinner: networkRequestInProgress, open: editModalVisible, editingReusablePackaging: editingReusablePackaging, onCancel: hideEditModal, onSave: onSave })] })] }));
};
export default ConsignmentReusablePackagingPanel;
